<template>
  <div>
    <DataTable :data-model="'orders'"
               :display-name-plural="$t('entities.Order.Plural')"
               :display-name-singular="$t('entities.Order.Singular')"
               :permission-name="'Orders'"
               :allow-delete="false"
               :allow-create="false"
               :allow-edit="false"
               :exclude-fields="['id', 'finalized']">
      <template #cell(complete)="row">
        {{ $t('common.'+row.item.complete) }}
      </template>
      <template v-if="productTypes.length !== 0"
                #cell(productTypeId)="row">
        {{ productTypes.find(x => x.id === row.item.productTypeId).name }}
      </template>
      <template #cell(paidBy)="row">
        {{ $t('payment.status.'+row.item.paidBy) }}
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="$t('common.FinalizeOrder')"
          :enterable="false"
          placement="top"
          v-if="$auth.check(
            'Permissions.AdminPanel.Customers.Edit'
          ) && row.item.complete && !row.item.finalized">
          <b-button class="finalizeOrderBtn mx-1"
                    @click="orderId = row.item.id; $refs.finalizeOrderModal.show();">
            <font-awesome-icon class="fa-xs"
                               icon="check" />
          </b-button>
        </el-tooltip>
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="finalizeOrderModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.FinalizeOrder') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.RealyFinalizeOrderQuestion') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="orderId = null; $refs.finalizeOrderModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="finalizeOrder();">
          {{ $t('common.Yes') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      productTypes: [],
      orderId: null
    };
  },
  created() {
    this.axios.get('/admin/ProductTypes')
      .then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          this.productTypes = res.data.result;
        }
        Promise.resolve(this.productVouchers);
      })
      .catch((err) => Promise.reject(err));
  },
  methods: {
    finalizeOrder() {
      this.axios.put('/admin/orders/finalizeorder', {
        OrderId: this.orderId
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('FinalizeOrder.SuccessToast.Body'), {
          title: this.$t('FinalizeOrder.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.orderId = null;
        this.$refs.finalizeOrderModal.hide();
        this.$router.go();
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('FinalizeOrder.FailToast.Body'), {
          title: this.$t('FinalizeOrder.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        this.orderId = null;
        this.$refs.finalizeOrderModal.hide();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.finalizeOrderBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #8FBC8F;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken(#8FBC8F, 10%);
    color: $text-on-secondary;
  }
}
</style>
